<template>
  <div id="triadTab" class="triadTab">
    <div v-module="{ code: $moduleConstantes.MODULE_STUDEA_REGISTRATION }">
      <router-link
        v-if="displayRegistrationButton()"
        v-access:[permissions]="{
          access: accessManager().ALL,
          code: studeaManagerManager().STUDEA_MANAGER_REGISTRATION_DASHBOARD,
        }"
        v-tooltip="{ title: $t('page.registration_dashboard') }"
        :to="{ name: 'RegistrationList' }"
        class="triadTab__button btnStyle"
        @click="resetContent"
      >
        <FontAwesomeIcon class="triadTab__icon" icon="fa-light fa-users-gear" />
      </router-link>
    </div>
    <router-link
      v-if="displayTrainingListButton()"
      v-tooltip="{ title: $t('page.training_list') }"
      :to="{ name: 'TrainingList' }"
      class="triadTab__button btnStyle"
      @click="resetContent"
    >
      <FontAwesomeIcon class="triadTab__icon" icon="fa-light fa-screen-users" />
    </router-link>
    <router-link
      v-if="displayTrainingCourseConfigButton()"
      :key="trainingCourse"
      v-tooltip="{
        title: $t('studea_manager.home.title') + (design && design.label ? design.label.toLowerCase() : ''),
      }"
      :to="{
        name: 'studeaManagerLayout',
        params: { trainingCourseId: trainingCourseId },
      }"
      class="triadTab__button btnStyle"
      @click="resetContent"
    >
      <FontAwesomeIcon class="triadTab__icon" icon="fa-light fa-gear" />
    </router-link>
    <div v-if="displayTriadSelectButton()" class="triadTab__item">
      <button
        v-tooltip="{ title: $t('triadList') }"
        class="triadTab__button btnStyle"
        @click="openContent($event, 'triads')"
      >
        <FontAwesomeIcon class="triadTab__icon" icon="fa-light fa-users" />
      </button>
      <div class="triadTab__content -triadList">
        <TriadUsersListComponent
          :lateralTab="true"
          :search="true"
          :trainingCourse="trainingCourse"
          @triadLoaded="resetContent"
        />
      </div>
    </div>
    <router-link
      v-if="displayTrainingCourseListButton()"
      v-tooltip="{ title: $t('page.training_course_list') }"
      :to="{ name: 'TrainingCourseList' }"
      class="triadTab__button btnStyle"
      @click="resetContent"
    >
      <FontAwesomeIcon class="triadTab__icon" icon="fa-light fa-graduation-cap" />
    </router-link>
    <router-link
      v-if="displayRegistrationApprenticeOrCompanyListButton()"
      v-tooltip="{ title: $t('page.registration_list') }"
      :to="{ name: setRegistrationListPath() }"
      class="triadTab__button btnStyle"
    >
      <FontAwesomeIcon class="triadTab__icon" icon="fa-light fa-list" />
    </router-link>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useTrainingCourseStore } from "@/store/training-course/training-course";
import { useTriadStore } from "@/store/triad/triad";
import { useUserStore } from "@/store/user/user";
import { usePlatformStore } from "@/store/platform/platform";
import TriadUsersListComponent from "@/components/triad/TriadUsersListComponent.vue";
import { accessManager } from "@/services/security/access-manager";
import { studeaManagerManager } from "@/services/studea-manager/studea-manager-manager";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { registrationConstante } from "@/constantes/registration";
import { apiConnection } from "@/services/api-connection";
import { tabsManager } from "@/services/utilities/tabs-manager";

export default {
  name: "TriadSelectComponent",
  components: { FontAwesomeIcon, TriadUsersListComponent },
  data() {
    return {
      content: "",
      label: "",
      trainingCourseId: null,
      btnDisplayed: [],
    };
  },
  computed: {
    ...mapState(useTrainingCourseStore, {
      trainingCourses: (store) => store.trainingCourseList,
      trainingCourse: (store) => store.trainingCourse,
    }),
    ...mapState(useTriadStore, {
      triad: (store) => store.triad,
    }),
    ...mapState(useUserStore, {
      user: (store) => store.user,
    }),
    ...mapState(usePlatformStore, {
      design: (store) => store.design,
    }),

    isApprenticeOrCompany() {
      return (
        this.user &&
        this.user?.target === "registration" &&
        (this.actorType === registrationConstante.REGISTRATION_ACTOR_APPRENTICE ||
          this.actorType === registrationConstante.REGISTRATION_ACTOR_COMPANY)
      );
    },

    actorType() {
      return this.user?.targetParams?.registrationActorType;
    },
  },
  watch: {
    "trainingCourse.id"() {
      this.setTrainingCourseId();
    },
  },

  mounted() {
    this.setTrainingCourseId();
  },

  methods: {
    studeaManagerManager() {
      return studeaManagerManager;
    },
    accessManager() {
      return accessManager;
    },
    setTrainingCourseId() {
      if (this.trainingCourse && this.trainingCourse.id && this.trainingCourse.isStudeaManager) {
        this.trainingCourseId = this.trainingCourse.id;
      }
      if (this.trainingCourseId) {
        window.localStorage.setItem("studea-oldTrainingCourse", this.trainingCourseId);
      }
    },

    openContent(event, type = null) {
      if (type === "triads") {
        this.loadTriads();
      }
      const target = event.currentTarget.parentNode;
      if (!target.classList.contains("expanded")) {
        const backdrop = document.getElementById("backdrop");
        const triadTab = document.getElementById("triadTab");
        const $this = this;

        if (!backdrop || !triadTab) return;

        this.resetContent();
        backdrop.classList.add("show");
        triadTab.classList.add("open");
        backdrop.addEventListener(
          "click",
          function () {
            $this.resetContent();
            backdrop.classList.remove("show");
            setTimeout(function () {
              triadTab.classList.remove("open");
            }, 200);
          },
          { once: true },
        );

        setTimeout(function () {
          target.classList.add("expanded");
        }, 200);
      }
    },

    resetContent() {
      const items = [].slice.call(document.querySelectorAll(".triadTab__item"));
      const backdrop = document.getElementById("backdrop");
      const triadTab = document.getElementById("triadTab");
      if (triadTab && triadTab.classList.contains("open")) {
        setTimeout(function () {
          triadTab.classList.remove("open");
        }, 200);
      }
      if (backdrop) {
        backdrop.classList.remove("show");
      }
      items.map((item) => {
        item.classList.remove("expanded");
        item.classList.add("closing");
        setTimeout(function () {
          item.classList.remove("closing");
        }, 200);
      });
    },

    loadTriads() {
      if (this.trainingCourse && (!this.trainingCourse.crews || !Object.keys(this.trainingCourse.crews).length)) {
        this.fetchTrainingCourseTriads({
          id: this.trainingCourse.id,
          archive: this.trainingCourse.archive ? 2 : 1,
          search: false,
        });
      }
    },

    displayTrainingCourseListButton() {
      return !tabsManager.isTrainingCourseList(this.$route) && !this.isApprenticeOrCompany;
    },

    displayTrainingCourseConfigButton() {
      return (
        this.trainingCourseId &&
        !tabsManager.isStudeaManagerArea(this.$route) &&
        !tabsManager.isTrainingCourseList(this.$route) &&
        tabsManager.isRouteAvailableForTrainingCourseListButton(this.$route) &&
        !tabsManager.isStudeaManagerTraining(this.$route) &&
        !tabsManager.isRegistration(this.$route) &&
        !tabsManager.isPreRegistration(this.$route)
      );
    },

    displayTriadSelectButton() {
      return (
        (this.user.isStudeaManager || this.user.isAdmin) &&
        !tabsManager.isTrainingCourseList(this.$route) &&
        tabsManager.isRouteAvailableForTrainingCourseListButton(this.$route) &&
        !tabsManager.isStudeaManagerTraining(this.$route) &&
        !tabsManager.isRegistration(this.$route) &&
        !tabsManager.isPreRegistration(this.$route)
      );
    },

    displayTrainingListButton() {
      return (
        this.user.isStudeaManagerOnTraining &&
        tabsManager.displayTrainingListButton(this.$route, this.trainingCourseId, this.isApprenticeOrCompany, this.user)
      );
    },

    displayRegistrationButton() {
      return tabsManager.displayRegistrationButton(this.$route, this.trainingCourseId, this.isApprenticeOrCompany);
    },

    setRegistrationListPath() {
      switch (this.actorType) {
        case registrationConstante.REGISTRATION_ACTOR_APPRENTICE:
          return "ApprenticeContractList";
        case registrationConstante.REGISTRATION_ACTOR_COMPANY:
          return "CompanyContractList";
      }
    },

    displayRegistrationApprenticeOrCompanyListButton() {
      return this.isApprenticeOrCompany && !apiConnection.getMagicLinkToken();
    },

    ...mapActions(useTrainingCourseStore, {
      fetchTrainingCourseTriads: "fetchTrainingCourseTriads",
    }),
  },
};
</script>

<style lang="scss" scoped>
.triadTab {
  position: fixed;
  right: 15px;
  bottom: 25px;
  display: flex;
  z-index: 2;
  gap: 15px;

  @include up-to-md {
    display: none;
  }

  &__button {
    border: none;
    color: $white !important;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $radius $radius 0 0;

    @include dark-theme {
      border: none;
    }

    &:hover {
      background: $white !important;

      @include dark-theme {
        background: $m-color_10 !important;
      }

      .triadTab__icon {
        color: var(--secondary-color);

        @include dark-theme {
          color: $dark-text !important;
        }
      }
    }
  }

  &__icon {
    font-size: 25px;
  }

  &__content {
    background: $white;
    position: absolute;
    bottom: -25px;
    right: 0;
    min-height: 350px;
    max-height: 350px;
    overflow: scroll;
    border-radius: $radius $radius 0 0;
    border: 1px solid $m-color_3;
    z-index: 1;
    padding: 20px;
    transform: translateY(100%);
    transition: all 300ms ease;

    &.-triadList {
      max-width: 650px;
      min-width: 650px;
    }
  }

  &.open {
    z-index: 10000;

    .triadTab__content {
      transform: translateY(0);
    }
  }
}
</style>
